import { customerApi } from "../../utils/apiConfig";

const getAuthHeaders = () => {
  const token = sessionStorage.getItem("token");

  return {
    Authorization: token ? `Bearer ${token}` : "",
  };
};

const buildFormData = (files, options = {}) => {
  const formData = new FormData();

  files.forEach((file) => formData.append("xmlFiles", file));

  ["companyName", "diibInfo", "expiryDate", "materialName"].forEach(
    (field) => {
      const value = String(options[field] || "").trim();
      if (value) formData.append(field, value);
    }
  );

  return formData;
};

export const previewDomesticPurchaseXmlsApi = (
  files,
  options = {},
  onUploadProgress
) => {
  return customerApi.post(
    "/muhasebe/yurt-ici-alimlar/xml-onizle",
    buildFormData(files, options),
    {
      headers: getAuthHeaders(),
      onUploadProgress,
    }
  );
};

export const exportDomesticPurchaseXmlsApi = (
  files,
  options = {},
  onUploadProgress
) => {
  return customerApi.post(
    "/muhasebe/yurt-ici-alimlar/excel-olustur",
    buildFormData(files, options),
    {
      headers: getAuthHeaders(),
      responseType: "blob",
      onUploadProgress,
    }
  );
};
